import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCredentialsId } from '@ovpn-ui-toolkit/mf-common';

import { selectFrieldlyRole, selectIsLoggedIn } from '../selectors';
import { pushToDataLayer } from '../utils';

function useGtag() {
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const friendlyRole = useSelector(selectFrieldlyRole);
    const credentialsId = useSelector(selectCredentialsId);

    useEffect(() => {
        if (isLoggedIn) {
            pushToDataLayer({
                event: 'pageview',
                credentials_id: credentialsId,
                user_role: friendlyRole,
            });
        }
    }, [credentialsId, isLoggedIn, friendlyRole]);
}

export default useGtag;
